/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ID } from '../models/ID';
import type { KundeDaten } from '../models/KundeDaten';
import type { KundeMitBerechtigungen } from '../models/KundeMitBerechtigungen';
import type { KundeSeite } from '../models/KundeSeite';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class KundenService {

  constructor(public readonly httpRequest: BaseHttpRequest) {}

  /**
   * @param suche
   * @param sortierung Die Sortierung der Ergebnisse als komma-separierte Liste.
   * Jeder Eintrag der Liste hat die Form `[-]<feld>`, wobei das Minus eine absteigende Sortierung angibt.
   * Beispiel: `benutzerId,-zeitpunkt` bedeutet "aufsteigend nach `benutzerId`, dann absteigend nach `zeitpunkt`.
   *
   * @param seite Der 0-basierte Index der Seite. Per default wird die erste Seite geladen.
   *
   * @param max Die maximale Anzahl an Ergebnissen pro Seite.
   * Wenn dieser Parameter nicht angegeben oder negativ ist, werden alle Ergebnisse ab der angefragten Seite geladen.
   *
   * @returns KundeSeite Liste der Kunden
   * @throws ApiError
   */
  public sucheKunden(
    suche?: string,
    sortierung?: string,
    seite?: number,
    max: number = 100,
  ): CancelablePromise<KundeSeite> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/kunden',
      query: {
        'suche': suche,
        'sortierung': sortierung,
        'seite': seite,
        'max': max,
      },
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
      },
    });
  }

  /**
   * @param requestBody
   * @returns KundeMitBerechtigungen der erstellte Kunde
   * @throws ApiError
   */
  public erstelleKunde(
    requestBody: KundeDaten,
  ): CancelablePromise<KundeMitBerechtigungen> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/kunden',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
      },
    });
  }

  /**
   * @param kundeId
   * @returns KundeMitBerechtigungen der Kunde
   * @throws ApiError
   */
  public getKunde(
    kundeId: ID,
  ): CancelablePromise<KundeMitBerechtigungen> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/kunden/{kundeId}',
      path: {
        'kundeId': kundeId,
      },
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
      },
    });
  }

  /**
   * @param kundeId
   * @param requestBody
   * @returns KundeMitBerechtigungen der aktualisierte Kunde
   * @throws ApiError
   */
  public updateKunde(
    kundeId: ID,
    requestBody: KundeDaten,
  ): CancelablePromise<KundeMitBerechtigungen> {
    return this.httpRequest.request({
      method: 'PUT',
      url: '/kunden/{kundeId}',
      path: {
        'kundeId': kundeId,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
      },
    });
  }

}
